<app-header></app-header>

<section class="skills my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-7 pt-4 pt-lg-0 content aos-init aos-animate" data-aos="fade-left" data-aos-delay="100">
                <h3 class="mb-3">About ParkUpp Collector</h3>
                <small class="fst-italic">A tribute to Andrew Bradford</small>
                <br />
                <br />

                <p>
                    My late brother, Andrew was a lover and collector of classic cars. He restored his first classic at 15 and I can’t say I remember a time when he didn’t have some classic stored in
                    a garage somewhere...
                </p>
                <p>
                    His family home had a double garage, too short for a Lincoln Continental, and two too few to accommodate the increasing subjects of his passion. Cars were kept in the garages of
                    friends, and family, in empty office basements and in dire circumstances on “rotation” at Hyde Park Corner.
                </p>
                <p>
                    In the years it took to dispose of his collection, I got to spend time in a few of them. I will never forget the joy of driving the E-Type and Aston on the N3 from Johannesburg to
                    Nottingham Road and back .
                </p>
                <p>
                    I moved to Cape Town and bought a Victorian - semi in Green Point without off-street parking. My solution was a Smart Fortwo to leave on the open streets and an SUV parked in the
                    basement of Cape Quarter. Born of those memorable drives along the N3, I found myself increasingly drawn to the ever classic design and quality build of a single manufacturer. And
                    so I recently started on my own quiet journey of collecting reminded of my wonderful brother whose many gifts to me now include sharing his exhilaration of being behind the wheel.
                </p>
                <p>
                    I acquired ParkUpp as a strategic addition to my community of inter-related Prop-tech businesses. We have re-written the technology to reflect our core principles of simplicity,
                    necessity and excellence. Thoroughly enjoying being a customer on the new site. As ParkUpp evolves, I of course wanted us to cater for the car collector. It is appropriate that I
                    dedicate ParkUpp the Collector to the ongoing memory of Andrew. I think he would have liked what we are doing here ……it would have given him the freedom to collect.
                </p>
                <p>-- Mark Bradford</p>

                <div class="mt-4">
                    <a href="/map-search?parkingType=PARKING_COLLECTOR" class="btn btn-primary" target="_blank">Explore ParkUpp Collector</a>
                </div>
            </div>
            <div class="col-lg-5 d-flex align-items-center aos-init aos-animate" data-aos="fade-right" data-aos-delay="100">
                <img
                    src="https://firebasestorage.googleapis.com/v0/b/parkupp-test.appspot.com/o/public%2Fwebsite%2Fpexels-cottonbro-4480464.jpg?alt=media&token=3fc8a3f4-0036-4d6d-abe2-9e1df78c99c3"
                    class="img-fluid"
                    alt=""
                />
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
